import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import Button from "../button"
import SbImageService from "../../helpers/SbImageService"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"

const Program = ({ blok }) => (
  <SbEditable content={blok}>
    <div
      className={`program animated card card--pd-md ${
        blok.isMinimal ? "program--minimal" : ""
      } ${blok.class}`}
    >
      {!blok.isMinimal && (
        <div
          className="program__image"
          style={{
            backgroundImage: `url("${SbImageService(blok.card_image)}")`,
          }}
        ></div>
      )}
      <div className="program__card-content">
        <p className="program__number">{blok.number}</p>
        <h4 className="program__heading">{blok.title}</h4>
        {blok.description && (
          <div className="program__copy">
            {
              unified()
                .use(remarkParse)
                .use(remarkRehype)
                .use(rehypeReact, {
                  createElement: React.createElement,
                  components: remarkReactComponents,
                  Fragment: React.Fragment
                })
                .processSync(blok.description).result
            }
          </div>
        )}
        {blok.button &&
          blok.button.map((content) => (
            <Button
              key={content._uid}
              blok={content}
              className="program__btn"
            />
          ))}
      </div>
    </div>
  </SbEditable>
)

Program.propTypes = {
  blok: PropTypes.shape({
    number: PropTypes.string,
    title: PropTypes.string,
    card_image: PropTypes.string,
    description: PropTypes.string,
    button: PropTypes.arrayOf(PropTypes.object),
    class: PropTypes.string,
    isMinimal: PropTypes.bool,
  }).isRequired,
}

export default Program
